import React from "react";
import heroBg from "../assets/otherimages/heroimage.png";
import { Helmet } from "react-helmet";
const Hero = () => {
  return (
    <>
     <Helmet>
        <title>Blue Diamond Rent Car | Luxury & Affordable Car Rentals in Dubai</title>
        <meta
          name="description"
          content="Find, book, and rent luxury and affordable cars easily with Blue Diamond Rent Car. Experience top service and premium vehicles across Dubai."
        />
        <link rel="canonical" href="https://bluediamondrentcar.com/" />
      </Helmet>
    <section
      id="home"
      className="relative h-[90vh] sm:h-screen flex items-center justify-center text-center text-white"
    >
      {/* Background Image */}
      <img
        src={heroBg}
        alt="Car Background"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />

      {/* Overlay (gradient for readability) */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl px-4 sm:px-6 lg:px-12">
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold mb-4 leading-snug">
          Find, Book and Rent a Car Easily
        </h1>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 leading-relaxed text-gray-200">
          Experience premium and luxury car rentals at unbeatable rates. 
          Rent a car whenever and wherever you need it. 
          Drive in style and elevate every journey with our affordable, top-tier rental service.
        </p>
        <a
          href="#cars"
          className="inline-block bg-white text-[#0B2F6B] font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg shadow-lg hover:bg-gray-100 transition text-sm sm:text-base md:text-lg"
        >
          Explore Cars
        </a>
      </div>
    </section>
    </>
    
  );
};

export default Hero;
